// Admin image upload (backend/src/game/uploads): POST /admin/uploads/:folder,
// PNG/JPEG/WebP up to 5 MB, validated by bytes server-side. The returned URL
// (/api/uploads/<folder>/<name>) is what the owning record stores.
import { api } from './client';

/** Must match UPLOAD_FOLDERS in backend/src/game/uploads/uploads.service.ts. */
export type UploadFolder = 'meta' | 'cms';

export interface StoredImage {
  url: string;
  width: number;
  height: number;
  format: 'png' | 'jpeg' | 'webp' | 'ico';
}

/** FormData body with one `file` field, as the backend's FileInterceptor('file') expects. */
export function fileForm(file: File): FormData {
  const fd = new FormData();
  fd.append('file', file);
  return fd;
}

/** The client defaults to JSON; multer needs the multipart body untouched. */
export const MULTIPART = { headers: { 'Content-Type': 'multipart/form-data' } };

export const uploadAdminImage = (file: File, folder: UploadFolder) =>
  api.post<StoredImage>(`/admin/uploads/${folder}`, fileForm(file), MULTIPART).then((r) => r.data);
